import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';

export default class ProductReviewApi extends ApiClient {
  public constructor(options: ApiClientOptions = {}) {
    super(getServiceUrl('review'), options);
  }

  public getReview(productKeyId: number) {
    const query = `/review/pending/v1/${productKeyId}/details`;
    return this.get(query);
  }

  public getSummary(productKeyId: number) {
    const query = `/review/pending/v1/${productKeyId}/summary`;
    return this.get(query);
  }
}
